import React, { useState } from "react";
import {
  Box,
  Typography,
  Container,
  Button,
  CircularProgress,
  Paper,
  Divider,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { investorApi } from "../../../api/api";

// Custom styled file input
const Input = styled("input")({
  display: "none",
});

const WalletPending = () => {
  const navigate = useNavigate();
  const userId = useSelector((state) => state.user.userId);
  const location = useLocation();
  const { id, Amount } = location.state || {};

  const [selectedImage, setSelectedImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleImagePick = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setSelectedImage(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async () => {
    if (!imageFile) {
      alert("Please select a payment proof image.");
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append("transactionId", id);
    formData.append("screenshot", imageFile);

    try {
      const response = await investorApi.addWalletPayment(formData);
      if (response.status === 200) {
        alert("Payment proof uploaded successfully!");
        navigate(-1);
      } else {
        alert("Failed to upload payment proof.");
      }
    } catch (error) {
      console.error("Upload Error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 6 }}>
      <Paper
        elevation={4}
        sx={{
          p: 4,
          borderRadius: 4,
          background: "#fefefe",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        }}
      >
        <Typography
          variant="h5"
          fontWeight="bold"
          gutterBottom
          sx={{ color: "#1a237e", textAlign: "center" }}
        >
          Wallet Payment Upload
        </Typography>

        <Divider sx={{ mb: 3 }} />

        {Amount >= 0 ? (
          <Box
            sx={{
              background: "#f5f5f5",
              borderRadius: 2,
              p: 2,
              mb: 3,
              textAlign: "center",
            }}
          >
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              color="text.secondary"
            >
              Invested Amount
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="#2e7d32">
              ₹{Amount}
            </Typography>
          </Box>
        ) : (
          <Typography color="text.secondary">
            No pending wallet transactions.
          </Typography>
        )}

        {/* Image Picker Button */}
        <label htmlFor="upload-proof">
          <Input
            accept="image/*"
            id="upload-proof"
            type="file"
            onChange={handleImagePick}
            disabled={uploading}
          />
          <Button
            component="span"
            variant="outlined"
            fullWidth
            startIcon={<CloudUploadIcon />}
            sx={{
              py: 1.2,
              borderRadius: 2,
              textTransform: "none",
              mb: 2,
              fontWeight: 600,
            }}
            disabled={uploading}
          >
            {uploading ? "Uploading..." : "Select Payment Proof"}
          </Button>
        </label>

        {/* Image Preview */}
        {selectedImage && (
          <Box
            component="img"
            src={selectedImage}
            alt="Payment Proof"
            sx={{
              width: "100%",
              height: 220,
              objectFit: "cover",
              borderRadius: 2,
              mb: 2,
              border: "1px solid #ddd",
            }}
          />
        )}

        {/* Submit Button */}
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={uploading}
          sx={{
            py: 1.2,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "1rem",
          }}
        >
          {uploading ? "Uploading..." : "Submit"}
        </Button>

        {/* Loader */}
        {uploading && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <CircularProgress />
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default WalletPending;
